module.exports = __webpack_public_path__ + "img/auth4.0b7f8ee8.png";